import * as moment from 'moment-mini';
import { BaseModel } from '../base.model';
import { MasterplanActivity } from './masterplanActivity.model';

export class MasterplanV2Model extends BaseModel {
  public id: number;
  public name: string;
  public startDate: Date;
  public startDateMoment: moment.Moment;

  public masterplanActivities: MasterplanActivity[];
  constructor(data: any = {}) {
    super(data);

    this.id = data.id;
    this.name = data.name;
    this.masterplanActivities = data.masterplanActivities?.map(mpShift => new MasterplanActivity(mpShift)) || [];
    this.startDate = (data.startDate && new Date(data.startDate)) || null;
    this.startDateMoment = moment(this.startDate).utc();
  }

  public getNumWeeks(): number {
    return this.masterplanActivities.length / 7;
  }
}
